import Vue from 'vue'
import { Button, Card, Row, Col, Modal, Spin, List, Divider, DatePicker, ConfigProvider } from 'ant-design-vue';
Vue.use(Button).use(Card).use(Row).use(Col).use(Modal).use(Spin).use(List).use(Divider).use(DatePicker).use(ConfigProvider)
